import {Card, CardBody, Col, Container, Row} from "reactstrap";
import React, {Component, Fragment} from "react";
import {getData} from "../../api/doLogin";

export class Email extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      error: false,
      user: null,
      pass: null
    }
    this.formRef = React.createRef();
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  componentWillUnmount() {

  }

  submitForm() {
    this.formRef.current.submit()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const form = document.getElementById("EmailWindow");
    if (form) {
      this.submitForm()
    }
  }


  getData(category = "0") {
    var self = this;
    self.setState({showIndicator: true, activeTab: Number(category)});
    getData(`myemail`, {}, this.props.token)
      .then((data) => {
        if (data.status === "success") {
          // console.log(data.data);
          self.setState({
            user: data.data.AFBNEmail,
            pass: data.data.AFBNPass,
            error: false,
            dataLoaded: true,
          });
        } else {
          self.setState({error: true, user: null, pass: null});
        }
      })
      .catch(error => {
        console.error(error);
        self.setState({error: true, user: null, pass: null});
      });
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              {!this.state.error ?
                <Fragment>
                  <div className="clearfix">
                    <h4 className="pt-4" style={{textAlign: 'center'}}>Please wait while we attempt to connect you to
                      your
                      email account....</h4>
                  </div>
                  <Card>
                    <CardBody>
                      <div className="sk-wave">
                        <div className="sk-rect sk-rect1"></div>
                        &nbsp;
                        <div className="sk-rect sk-rect2"></div>
                        &nbsp;
                        <div className="sk-rect sk-rect3"></div>
                        &nbsp;
                        <div className="sk-rect sk-rect4"></div>
                        &nbsp;
                        <div className="sk-rect sk-rect5"></div>
                      </div>
                      {this.state.user && this.state.pass && (
                        <form ref={this.formRef} id="EmailWindow" method="post"
                              action="https://mail.liveoutlook.net/owa/auth.owa">
                          <input type="hidden" name="destination" value="https://mail.liveoutlook.net/owa"/>
                          <input type="hidden" name="flags" value="4"/>
                          <input type="hidden" name="forcedownlevel" value="0"/>
                          <input type="hidden" name="username" value={this.state.user}/>
                          <input type="hidden" name="password" value={this.state.pass}/>
                          <input name="isUtf8" value="1" type="hidden"/>
                          <input type="submit" style={{display: "none"}}/>
                        </form>
                      )}
                    </CardBody>
                  </Card>
                </Fragment>
                :
                <div className="clearfix">
                  <h4 className="pt-4" style={{textAlign: 'center'}}>There was an error connecting to your email
                    account. Refresh and try again or contact support.</h4>
                </div>
              }
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Email/Email.js